import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import SideBar from "./SideBar/SideBar";
import { Outlet } from "react-router-dom";
// import Navbar from "./Navbar"; // Commented out - using v2 TopBar instead
import Loader from "./ui/Loader";
import Notifications from "./push-notifications/Notifications";
// import GlobalSearch from "./GlobalSearch";
import { selectUser } from "./auth/auth.selector";
// import OdmLeadAlerts from "./push-notifications/OdmLeadAlerts";

function LoadingScreen() {
  return (
    <div className="flex-k js-center-k items-center-k h-75vh-k">
      <Loader color="#ffffff" size={"large"} />
    </div>
  );
}

const Layout = () => {
  const authData = useSelector(selectUser);

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  return (
    <Suspense fallback={<LoadingScreen />}>
      <SideBar>
        <div className="child-wrapper">
          {/* <Navbar /> */} {/* Commented out - using v2 TopBar instead */}
          <Outlet />
          {authData && !isIOS() && <Notifications authData={authData} />}
          {/* {authData && !isIOS() && <OdmLeadAlerts />} */}
        </div>
      </SideBar>
      {/* <GlobalSearch /> */}
    </Suspense>
  );
};

export default Layout;
